import * as React from 'react'

import { Alert, Box, Icon, Text } from '@factorialco/deprecated-design-system'
import maxBy from 'lodash/maxBy'

import i18n from 'modules/core/lib/i18n'

import { calculateRatingAverageScore } from 'modules/performance_process/lib/calculateRatingAverageScore'
import {
  getResponseByType,
  isQuestionRating,
  isRatingAnswer,
} from 'modules/questionnaires/lib/helpers'
import type { QuestionnaireResponseContent } from 'modules/questionnaires/lib/types'

export const RatingAverageScore: React.FC<{ questionnaire: QuestionnaireResponseContent }> = ({
  questionnaire,
}) => {
  const ratingResponses = getResponseByType(questionnaire, 'rating')
  const ratingValues = ratingResponses
    .map(({ answer, question }) => {
      const value = answer && isRatingAnswer(answer) ? answer.answerRating?.value : null
      const maxScale =
        question && isQuestionRating(question) ? maxBy(question.scale, 'value')?.value : null

      if (value && maxScale) {
        return { value, maxScale }
      }

      return null
    })
    .filter(Boolean)

  const { displayScore } = calculateRatingAverageScore(ratingValues)

  return (
    <Alert color="note">
      <Box flexNoShrink flexDirection="row">
        <Icon.Medium icon="calculator" />
        <Text.Normal>
          {i18n.t('surveys.answer.performance_score', { score: displayScore })}
        </Text.Normal>
      </Box>
    </Alert>
  )
}
